import { DeleteIcon, FaroMenuItem } from "@faro-lotv/flat-ui";
import { JSX } from "react";

type DeleteNodeContextMenuActionItemProps = {
  /** Whether the delete action is disabled */
  disabled?: boolean;
  /** Callback function to handle the delete action */
  onDelete(): void;
};

/**
 * @returns context menu item for delete action
 */
export function DeleteNodeContextMenuActionItem({
  disabled,
  onDelete,
}: DeleteNodeContextMenuActionItemProps): JSX.Element {
  return (
    <FaroMenuItem
      key="delete"
      label="Delete"
      Icon={DeleteIcon}
      onClick={onDelete}
      disabled={disabled}
    />
  );
}
